import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

const { Text } = Typography;

const TextSeq = ({ seq }) => {
  if (seq === 0) {
    return <Text type="danger">Seq: please assign</Text>;
  }
  return <Text type="secondary">Seq: {seq}</Text>;
};

TextSeq.defaultProps = {
  seq: 0,
};

TextSeq.propTypes = {
  seq: PropTypes.number.isRequired,
};

export default TextSeq;
